"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.parseArticles = void 0;
var _editorialFetching = require("@ori/editorial-fetching");
/**
 * Utility to filter articles with thruthy data and map them to `ArticleBoxProps` type.
 * @returns Articles with thruthy data
 */ const parseArticles = (param)=>{
    let { articles } = param;
    return (articles !== null && articles !== void 0 ? articles : []).filter((article)=>!!article).filter((param)=>{
        let { editorialLink: { relativeUrl }, description, thumbnailUrl, title } = param;
        return !!relativeUrl && !!description && !!thumbnailUrl && !!title;
    }).map((param)=>{
        let { editorialLink: { relativeUrl }, description, themeTag, thumbnailUrl, title } = param;
        return {
            categoryTitle: themeTag,
            image: {
                alt: title,
                url: thumbnailUrl
            },
            introText: description,
            isVideoArticle: false,
            link: {
                relativeUrl,
                type: _editorialFetching.LinkType.EditorialArticle
            },
            title
        };
    });
};
exports.parseArticles = parseArticles;
